import { render, staticRenderFns } from "./Commercials.vue?vue&type=template&id=6d92f0e8&"
import script from "./Commercials.vue?vue&type=script&lang=js&"
export * from "./Commercials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports